import React, { useState, useEffect } from "react";
import styled, { keyframes } from "styled-components";

// Helper: check om cookie eksisterer
const getCookie = (name) => {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? match[2] : null;
};

// Helper: sæt cookie
const setCookie = (name, value, days) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
};

// Slide-up animation
const slideUp = keyframes`
  0% { transform: translateY(100%); opacity: 0; }
  100% { transform: translateY(0); opacity: 1; }
`;

// Fade-out animation
const fadeOut = keyframes`
  0% { transform: translateY(0); opacity: 1; }
  100% { transform: translateY(100%); opacity: 0; }
`;

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const [animateOut, setAnimateOut] = useState(false);

  useEffect(() => {
    const accepted = getCookie("cookiesAccepted");
    if (!accepted) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    setCookie("cookiesAccepted", "true", 365); // gem 1 år
    setAnimateOut(true);
    setTimeout(() => setVisible(false), 500); // match animation duration
  };

  if (!visible) return null;

  return (
    <Banner animateOut={animateOut}>
      <Message>
        Vi bruger cookies til at forbedre din oplevelse på siden.{" "}
        <a href="/privatlivspolitik" target="_blank" rel="noreferrer">
          Læs mere
        </a>
      </Message>
      <AcceptButton onClick={handleAccept}>Accepter</AcceptButton>
    </Banner>
  );
}

/* ========== Styled Components ========== */
const Banner = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #222;
  color: #fff;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  z-index: 999;
  font-size: 0.9rem;
  animation: ${(props) => (props.animateOut ? fadeOut : slideUp)} 0.5s ease
    forwards;
`;

const Message = styled.p`
  margin: 0;
  line-height: 1.4;
  flex: 1 1 auto;
  a {
    text-decoration: underline;
    color: #fff;
  }
`;

const AcceptButton = styled.button`
  background-color: #f8c000;
  border: none;
  padding: 8px 16px;
  color: #222;
  font-weight: bold;
  cursor: pointer;
  border-radius: 4px;
  flex: 0 0 auto;
  margin-top: 8px;

  @media (min-width: 500px) {
    margin-top: 0;
  }

  &:hover {
    opacity: 0.9;
  }
`;
